var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { staticClass: "row bg-white ", attrs: { show: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "col-12 mt-3" },
        [
          _c("b-form-input", {
            staticClass: "form-control",
            attrs: { placeholder: "Buscar", "data-cy": "search" },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 mt-3" },
        [
          _c(
            "b-table-simple",
            { attrs: { hover: "", small: "", responsive: "" } },
            [
              _c(
                "b-thead",
                [
                  _c(
                    "b-tr",
                    [
                      _c("b-th", { attrs: { scope: "col" } }, [_vm._v("Nº")]),
                      _c("b-th", { attrs: { scope: "col" } }, [
                        _vm._v("Fecha Subasta")
                      ]),
                      _c("b-th", { attrs: { scope: "col" } }, [
                        _vm._v("Coordinadora")
                      ]),
                      _c(
                        "b-th",
                        { staticClass: "text-center", attrs: { scope: "col" } },
                        [_vm._v(" acciones ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-tbody",
                _vm._l(_vm.list, function(subasta) {
                  return _c(
                    "b-tr",
                    { key: subasta.subastaId, attrs: { "data-cy": "auction" } },
                    [
                      _c("b-td", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Folio subasta",
                                expression: "'Folio subasta'"
                              }
                            ],
                            staticClass: "d-flex align-items-center"
                          },
                          [_vm._v(" " + _vm._s(subasta.folio) + " ")]
                        )
                      ]),
                      _c("b-td", { staticClass: "text-center" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("dateFormat")(subasta.fechaSubasta)) +
                            " "
                        )
                      ]),
                      _c("b-td", { staticClass: "text-truncate w-75" }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: subasta.gestoraNombre,
                                expression: "subasta.gestoraNombre"
                              }
                            ],
                            staticClass: "text-truncate w-75"
                          },
                          [_vm._v(" " + _vm._s(subasta.gestoraNombre) + " ")]
                        )
                      ]),
                      _c(
                        "b-td",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "outline-danger",
                                "data-cy": "postule"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onPostule(subasta.subastaId)
                                }
                              }
                            },
                            [_vm._v(" Seleccionar ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 text-right" },
        [
          _c("ListPagination", {
            attrs: { show: _vm.list.length, pages: _vm.pages },
            on: { change: _vm.changePage },
            model: {
              value: _vm.page,
              callback: function($$v) {
                _vm.page = $$v
              },
              expression: "page"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }